export const getFindCallNumberLoaded = (state) =>
  state.vocalassistant.findCallNumberLoaded;
export const getFindCallNumberError = (state) =>
  state.vocalassistant.findCallNumberError;
export const getCallNumber = (state) => state.vocalassistant.callNumber;
